<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="copy-project-leads-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Copy Leads
            </h4>
          </div>

          <div class="modal-body">
            <TypeaheadFormGroup
                v-model="targetProject"
                name="project_id"
                label="Target Project"
                help-text="The project to copy the leads to."
                endpoint="/api/v2/projects"
                :params="{'filter[status]': 'active'}"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import LoadingSpinner from "../../../Layout/LoadingSpinner.vue";
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {LoadingSpinner, SelectFormGroup,TypeaheadFormGroup},

  props: {
    selected: {
      type: Array
    }
  },

  data() {
    return {
      targetProject: null,

      shared: store,
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      Promise
          .all(this.selected.map(projectLead => http.post('/api/v2/project-leads', {
            project_id: this.targetProject,
            company_id: projectLead.attributes.company_id
          }).catch(() => {
          })))
          .then(() => {
            notify.success('The leads were copied')

            this.$emit('saved')

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.targetProject = null
    }
  }
}
</script>
